<div class="filter-menu" [class.filter-chips]="showFilterChips">
  <markant-chip
    class="filter-chip filter-menu-button"
    colorScheme="secondary"
    [label]="'common.addFilter' | transloco"
    [disabled]="disabled"
    [readonly]="disabled"
    (click)="dialogOpen = true"
  >
    <markant-icon slot="icon-leading" icon="m_plus"></markant-icon>
  </markant-chip>
  <ng-container *ngIf="showFilterChips">
    <markant-chip
      *ngFor="let filter of activeFilterList"
      class="filter-chip"
      colorScheme="secondary"
      [removable]="true"
      [label]="
        filter.filterOption.isTranslationKey
          ? (filter.filterOption.label | transloco)
          : filter.filterOption.label
      "
      (removeChip)="removeFilter(filter.groupKey, filter.filterOption.key)"
    >
    </markant-chip>
  </ng-container>
</div>
<markant-platform-modal-bridge>
  <markant-dialog *ngIf="dialogOpen" [open]="dialogOpen" (close)="onClose()">
    <div *ngIf="dialogOpen" class="filter-groups">
      <div
        class="filter-group"
        *ngFor="
          let filterGroup of filterGroups;
          last as last;
          trackBy: trackByFn
        "
      >
        <div class="filter-list">
          <ng-container *ngFor="let group of filterGroup">
            <markant-platform-filter-country
              *ngIf="filter[group.key].filterType; else checkboxes"
              [id]="group.key"
              [label]="group.label | transloco"
              [options]="filter[group.key].filterOptions"
              [selectedOptions]="activeFilter[group.key] || []"
              [resetNotifier$]="reset$"
              (filterChangeEmitter)="updateFilter($event)"
            >
            </markant-platform-filter-country>
            <ng-template #checkboxes>
              <div class="filter-group-item">
                <markant-platform-filter-checkboxes
                  [id]="group.key"
                  [label]="group.label | transloco"
                  [sorting]="filter[group.key].sorting"
                  [options]="filter[group.key].filterOptions"
                  [selectedOptions]="activeFilter[group.key] || []"
                  [resetNotifier$]="reset$"
                  (filterChangeEmitter)="updateFilter($event)"
                >
                </markant-platform-filter-checkboxes>
              </div>
            </ng-template>
          </ng-container>
        </div>
        <markant-seperator
          class="filter-group-separator"
          *ngIf="!last"
          orientation="vertical"
        ></markant-seperator>
      </div>
    </div>
    <div class="button-row">
      <markant-button
        colorScheme="primary"
        variant="clear"
        class="button-transparent-secondary-text"
        (click)="resetFilters()"
      >
        {{ 'common.reset' | transloco }}
      </markant-button>
      <markant-button colorScheme="primary" (click)="applyFilters()">
        {{ 'common.apply' | transloco }}
      </markant-button>
    </div>
  </markant-dialog>
</markant-platform-modal-bridge>
